import { render, staticRenderFns } from "./BulkSend.vue?vue&type=template&id=22999625"
import script from "./BulkSend.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkSend.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports